{
  "撮合运营跟进": "Connection follow-up",
  "未跟进": "Not followed up",
  "已联系发布方": "Publisher contacted",
  "双方洽谈中": "In discussion",
  "待补充业务资料": "Awaiting business information",
  "已约定下一步": "Next step agreed",
  "跟进完成": "Follow-up completed",
  "终止跟进": "Follow-up ended",
  "待回应": "Awaiting response",
  "已接受": "Accepted",
  "已拒绝": "Declined",
  "已撤回": "Withdrawn",
  "记录跟进": "Add follow-up",
  "保存跟进": "Save follow-up",
  "跟进记录已保存": "Follow-up saved",
  "跟进进度": "Follow-up progress",
  "联系日期": "Contact date",
  "联系结果": "Contact outcome",
  "填写联系渠道、实际回应与证据摘要": "Record the contact channel, actual response and supporting evidence",
  "请填写联系结果": "Enter the contact outcome",
  "下一步事项": "Next action",
  "填写待办事项、负责人和期限": "Enter the action, responsible person and deadline",
  "下次跟进日期": "Next follow-up date",
  "下次跟进日期不能早于联系日期": "The next follow-up date cannot precede the contact date",
  "对接跟进详情": "Connection details",
  "申请时间": "Requested at",
  "申请与回应": "Request and response",
  "申请企业": "Requesting company",
  "接收企业": "Receiving company",
  "申请说明": "Request details",
  "企业回应": "Company response",
  "人工跟进": "Manual follow-up",
  "最近跟进人": "Last operator",
  "最近跟进时间": "Last followed up",
  "运营跟进不改变企业申请状态；接受申请不代表成交。": "Follow-ups do not change the request status. Acceptance does not indicate a completed transaction.",
  "跟进记录": "Follow-up history",
  "暂无跟进记录": "No follow-ups yet",
  "关键词": "Keyword",
  "搜索合作事项或企业名称": "Search opportunities or companies",
  "合作事项": "Opportunity",
  "对接企业": "Companies",
  "申请方": "Applicant",
  "接收方": "Recipient",
  "申请状态": "Request status",
  "最近跟进": "Latest follow-up",
  "操作": "Actions",
  "详情": "Details",
  "对接记录": "Connections",
  "采购需求": "Purchase request",
  "供应信息": "Supply offer",
  "下次": "Next",
  "关联项目": "Linked projects",
  "暂无获授权的关联项目": "No authorized linked projects",
  "查看授权资料": "View authorized details",
  "获授权项目资料": "Authorized project details",
  "合作企业": "Partner company",
  "授权依据": "Authorization basis",
  "项目说明": "Project description",
  "创建企业授权的进展": "Progress authorized by the project owner",
  "暂无获授权的进展": "No authorized progress",
  "项目附件": "Project files",
  "附件未授权或当前账号无附件权限": "Files are not authorized or your account lacks file access",
  "项目不存在或未获授权": "Project not found or access not authorized",
  "获授权项目查看": "View authorized projects",
  "获授权项目附件下载": "Download authorized project files",
  "项目创建企业": "Project owner",
  "项目负责人": "Project manager",
  "进行中": "In progress",
  "已完成": "Completed",
  "商机已撤回": "Opportunity withdrawn"
}
